/**
 * Saved-searches API — mirrors smt_saved_search_handler.go.
 *
 *   GET    /api/v1/smt/saved-searches
 *   POST   /api/v1/smt/saved-searches
 *   PUT    /api/v1/smt/saved-searches/:id
 *   DELETE /api/v1/smt/saved-searches/:id
 *
 * All routes require a JWT; the backend scopes every read/write to user_id.
 */
import { request, requestData } from './client.ts';

export interface SavedSearch {
  id: number;
  user_id: number;
  name: string;
  /** Raw JSON string as stored in `smt_saved_searches.filters`. */
  filters: string;
  created_at: string;
  updated_at: string;
}

export interface SavedSearchInput {
  name: string;
  filters: Record<string, unknown>;
}

/** Parse the JSON-string filters column into the runtime object. */
export function parseFilters(s: SavedSearch): Record<string, unknown> {
  try {
    return JSON.parse(s.filters) as Record<string, unknown>;
  } catch {
    return {};
  }
}

export async function listSavedSearches(): Promise<SavedSearch[]> {
  return (await requestData<SavedSearch[] | null>('/smt/saved-searches')) ?? [];
}

export async function createSavedSearch(input: SavedSearchInput): Promise<SavedSearch> {
  return requestData<SavedSearch>('/smt/saved-searches', {
    method: 'POST',
    body: input,
  });
}

export async function updateSavedSearch(id: number, input: SavedSearchInput): Promise<SavedSearch> {
  return requestData<SavedSearch>(`/smt/saved-searches/${id}`, {
    method: 'PUT',
    body: input,
  });
}

export async function deleteSavedSearch(id: number): Promise<void> {
  await request<unknown>(`/smt/saved-searches/${id}`, { method: 'DELETE' });
}
